import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { CssBaseline, Box, Container } from '@mui/material';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import LocationManagement from './LocationScreen';
import CompanyScreen from './CompanyScreen';
import DepartmentScreen from './DepartmentScreen';
import DesignationScreen from './DesignationScreen';
import DeviceScreen from './DeviceScreen';
import StaffScreen from './StaffScreen';
import RouteScreen from './RouteScreen';
import BusScreen from './BusScreen';
import ParentScreen from './ParentScreen';
import EmployeeScreen from './EmployeeScreen';
import RecognitionScreen from './RecognitionScreen';
import ReportScreen from './ReportScreen';
import CompanyManagement from './CompanyScreen';
import ShiftPlanScreen from './ShiftPlanScreen';

const DRAWER_WIDTH = 260;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${DRAWER_WIDTH}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
        [theme.breakpoints.up('sm')]: {
            marginLeft: open ? 0 : `-${DRAWER_WIDTH}px`,
        },
    }),
);

function HomeScreen() {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [screen, setScreen] = useState('report');

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleSidebarItemClick = (newScreen) => {
        setScreen(newScreen);
        // On mobile, auto-close sidebar after selection
        if (window.innerWidth < 600) {
            setSidebarOpen(false);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.reload();
    };

    // staff: <StaffScreen />,
    // Map screen names to their respective components
    const screenComponents = {
        location: <LocationManagement />,
        company: <CompanyManagement />,
        department: <DepartmentScreen />,
        designation: <DesignationScreen />,
        device: <DeviceScreen />,
        routes: <RouteScreen />,
        bus: <BusScreen />,
        parent: <ParentScreen />,
        staff: <EmployeeScreen />,
        recognition: <RecognitionScreen />,
        report: <ReportScreen />,
        schedule: <ShiftPlanScreen />,
    };

    // Handle logout specially
    if (screen === 'logout') {
        handleLogout();
    }

    return (
        <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            <CssBaseline />
            <Header open={sidebarOpen} onMenuClick={toggleSidebar} />
            <Sidebar
                open={sidebarOpen}
                onItemClick={handleSidebarItemClick}
                drawerWidth={DRAWER_WIDTH}
                currentScreen={screen}
            />
            <Main open={sidebarOpen}>
                <Box sx={{ mt: 8, p: 2 }}>
                    <Container maxWidth="xl">
                        {screenComponents[screen]}
                    </Container>
                </Box>
            </Main>
        </Box>
    );
}

export default HomeScreen;